import React from 'react';
import { useParams, Link } from 'react-router-dom';
import PayrollBreakdownTable from '../components/PayrollBreakdownTable';
import './PayrollPeriodDetail.css';

const PayrollPeriodDetail = () => {
  const { period } = useParams();
  const decodedPeriod = decodeURIComponent(period);
  
  return (
    <div className="payroll-period-detail">
      <div className="page-header">
        <h1>
          {decodedPeriod === 'all' 
            ? 'All Payroll Periods' 
            : `Payroll Period: ${decodedPeriod}`}
        </h1>
        <Link to="/payroll-breakdown" className="back-link">
          &larr; Back to All Periods
        </Link>
      </div>
      <PayrollBreakdownTable activePeriod={decodedPeriod} />
    </div>
  );
};

export default PayrollPeriodDetail;